import { Link } from '@/i18n/routing';
import { MessageBox } from '@/shared/components/message-box';
import { Button } from '@/shared/components/primitives/button';

type SuccessMessageWithLinkProps = {
  successTitle?: string;
  successText?: string;
  linkText: string;
  linkHref: string;
};

export const SuccessMessageWithButtonLink = ({
  successTitle,
  successText,
  linkText,
  linkHref,
}: SuccessMessageWithLinkProps) => {
  return (
    <div role='status' className='mx-auto mt-8 flex max-w-xl flex-col items-center'>
      <MessageBox closable={false} type='success' className='mb-6 w-full' title={successTitle}>
        {successText && <span className='text-base'>{successText}</span>}
      </MessageBox>
      <Link href={linkHref}>
        <Button type='button'>{linkText}</Button>
      </Link>
    </div>
  );
};
